import React from 'react';

export const Georegion = (props) => {
  return (
    <div className="property-filter-block">
      {props?.georegion && (
        <label className="property-details-label">Georegion</label>
      )}
      <div className="property-pill-grid">
        {props?.georegion &&
          React.Children.toArray(
            props?.georegion?.map((geoReg) => (
              <button
                type="button"
                className={`property-pill ${
                  // eslint-disable-next-line eqeqeq
                  props?.getgeoregion == geoReg?.id
                    ? 'property-pill--active'
                    : ''
                }`}
                onClick={props?.handleGeoRegion}
                data-georegion={geoReg?.id}
              >
                {geoReg?.text}
              </button>
            )),
          )}
      </div>
    </div>
  );
};
